const clearTimeouts = () => {
    var id = window.setTimeout(() => { }, 0);

    while (id--) {
        window.clearTimeout(id);
    }
}

export {
    clearTimeouts
}


// WEBPACK FOOTER //
// ./src/Components/Services/Timeouts.js